/**
 * Unwrap Laravel-style `{ data: { id, status, ... } }` job payloads.
 * @param {unknown} payload
 * @returns {Record<string, unknown> | null}
 */
export function normalizeProfileImageJob(payload) {
  if (payload == null || typeof payload !== 'object') {
    return null;
  }

  let job = /** @type {Record<string, unknown>} */ (payload);

  if (
    job.data != null &&
    typeof job.data === 'object' &&
    ('id' in job.data || 'status' in job.data)
  ) {
    job = /** @type {Record<string, unknown>} */ (job.data);
  }

  return job;
}

/** @param {Record<string, unknown> | null} job */
export function isProfileImageJobComplete(job) {
  return job?.status === 'completed';
}

/** @param {Record<string, unknown> | null} job */
export function isProfileImageJobFailed(job) {
  return job?.status === 'failed';
}
